import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

export const requestCameraPermission = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ video: true });
    stream.getTracks().forEach(t => t.stop());
    return 'granted';
  } catch (err) {
    if (err?.name === 'NotAllowedError' || err?.name === 'PermissionDeniedError') {
      return 'denied';
    }
    return 'error';
  }
};

export const requestNotificationPermission = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      const status = await PushNotifications.requestPermissions();
      if (status.receive === 'granted') {
        try {
          await PushNotifications.register();
        } catch (regErr) {
          console.warn('Push register warning:', regErr);
        }
        return 'granted';
      }
      return status.receive;
    }

    if (!('Notification' in window)) return 'unsupported';
    const result = await Notification.requestPermission();
    return result;
  } catch (err) {
    console.error('Notification permission error:', err);
    return 'error';
  }
};

const STORAGE_KEY = 'nomofarma:permissionsOnboardingDone';

export const wasOnboardingShown = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};

export const markOnboardingShown = () => {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {}
};
